import React from 'react'
import { useThemeColors } from '../../ThemeContext'

interface FooterAllRightsProps {
	style?: React.CSSProperties
}

function FooterAllRights({ style }: FooterAllRightsProps) {
	const { textSecondary } = useThemeColors()
	return (
		<footer style={{ marginBottom: '10px', ...style }}>
			<p style={{ color: textSecondary, margin: 0 }}>&copy; 2023 All rights reserved V.1.0.3</p>
		</footer>
	)
}

export default FooterAllRights
